export class StatisticModel {
    firstTable: TableModel = new TableModel();
    secondTable: TableModel = new TableModel();
    thirdTable: TableModel = new TableModel();
    fourthdTable: TableModel = new TableModel();
    fifthTable: TableModel = new TableModel();
}

export class TableModel {
    header: string[] = [];
    body: string[][] = [];
}



// WEBPACK FOOTER //
// ./src/app/+app-custom/models/statistic.model.ts